<background-modal>
  <form [formGroup]="form">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-6">
        <h1 i18n>Reset Password</h1>
        <mat-form-field appearance="fill">
          <mat-label i18n>Email</mat-label>
          <input matInput i18n-placeholder placeholder="Email" formControlName="email" #email/>
          <mat-error i18n *ngIf="form.get('email')?.errors?.['required']">
            Username is required
          </mat-error>
          <mat-error i18n *ngIf="form.get('email')?.errors?.['email']">
            Email is in the wrong format
          </mat-error>
        </mat-form-field>
        <button class="btn btn-primary" [disabled]="!form.valid" i18n style="width: 100%;" (click)="authService.ForgotPassword(email.value)"> Reset Password
        </button>
        <div class="big-spacer">
          <a class="no_default" routerLink="/sign-in" i18n>
            Log In
          </a>
        </div>
      </div>
    </div>
  </form>
</background-modal>
